<template>
	<section class="grid">
		<main>
			<slot></slot>
		</main>
	</section>
</template>

<script>
export default {
	name: 'grid-group'
}
</script>

<style scoped>
.grid {}
</style>


// WEBPACK FOOTER //
// src/modules/ui/Grid.vue